import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {postJSONPromise} from 'util/Net';

const API_URL = `${getApiBaseForObjectType(DomainGraphType.PROCEDURE_RUN)}/analysis`;

interface UpdateProcedureRunAnalysisResponse {}

export function updateProcedureRunAnalysis(
  procedureRunId: string,
  analysisId: string,
  isLinked: boolean
): Promise<UpdateProcedureRunAnalysisResponse> {
  return postJSONPromise({url: API_URL, data: {procedureRunId, analysisId, isLinked}});
}
